// extracted by mini-css-extract-plugin
export default {"form_spinner":"FormSpinner_form_spinner__G4JOP","sk-bouncedelay":"FormSpinner_sk-bouncedelay__qK4G2","bounce1":"FormSpinner_bounce1__scORC","bounce2":"FormSpinner_bounce2__yw1WF"};